/** Status → Ant Design Tag color maps for HRMS documents. */

export const HRMS_GENERIC_STATUS_COLOR: Record<string, string> = {
  Draft: 'default',
  Pending: 'processing',
  Submitted: 'blue',
  Approved: 'success',
  Rejected: 'error',
  Cancelled: 'error',
  Closed: 'default',
  Active: 'success',
  Locked: 'purple',
  Computed: 'cyan',
  Open: 'blue',
  Paid: 'green',
  Booked: 'cyan',
  Issued: 'blue',
  Returned: 'default',
  Lost: 'error',
  WrittenOff: 'error',
  DutyResumed: 'cyan',
  Applied: 'success',
  PendingApproval: 'processing',
  Published: 'success',
  Screening: 'processing',
  Interview: 'blue',
  Offer: 'cyan',
  Hired: 'success',
  Withdrawn: 'default',
  TalentPool: 'purple',
  Sent: 'blue',
  Accepted: 'success',
  Scheduled: 'processing',
  Completed: 'success',
  Filled: 'success',
};

export const LEAVE_STATUS_COLOR: Record<string, string> = {
  ...HRMS_GENERIC_STATUS_COLOR,
  Pending: 'processing',
  Approved: 'success',
  DutyResumed: 'cyan',
  Closed: 'default',
  Rejected: 'error',
  Draft: 'default',
};

export const PAYROLL_STATUS_COLOR: Record<string, string> = {
  Draft: 'blue',
  Calculated: 'cyan',
  'Pending approval': 'gold',
  Approved: 'green',
  Rejected: 'red',
  Locked: 'purple',
  Paid: 'success',
};

export const ALLOCATION_STATUS_COLOR: Record<string, string> = {
  Current: 'green',
  Scheduled: 'blue',
  Expired: 'orange',
  Ended: 'default',
  Cancelled: 'red',
};

export function hrmsStatusColor(status?: string | null, map: Record<string, string> = HRMS_GENERIC_STATUS_COLOR): string {
  if (!status) return 'default';
  return map[status] || 'default';
}

/** Workflow stage helpers for WorkflowStrip. */
export type WorkflowStageStatus = 'wait' | 'process' | 'finish' | 'error';

export function buildLinearWorkflow(
  stages: string[],
  currentStatus: string,
  opts?: { cancelledStatuses?: string[]; rejectedStatuses?: string[] }
): { stages: Array<{ title: string; status: WorkflowStageStatus }>; current: number } {
  const cancelled = new Set(opts?.cancelledStatuses ?? ['Cancelled']);
  const rejected = new Set(opts?.rejectedStatuses ?? ['Rejected']);
  const isDead = cancelled.has(currentStatus) || rejected.has(currentStatus);
  const idx = stages.findIndex((s) => s === currentStatus);
  const current = idx >= 0 ? idx : 0;

  return {
    current: isDead ? Math.max(0, current) : current,
    stages: stages.map((title, i) => {
      if (isDead && i === current) return { title, status: 'error' as const };
      if (i < current) return { title, status: 'finish' as const };
      if (i === current) return { title, status: 'process' as const };
      return { title, status: 'wait' as const };
    }),
  };
}

export function showApprovalPanel(record: { approval_instance_id?: string | null; status?: string } | null | undefined): boolean {
  if (!record) return false;
  if (record.approval_instance_id) return true;
  const s = String(record.status || '');
  return /^Pending/i.test(s) || s === 'Submitted' || s === 'PendingApproval';
}
